import React,  {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from  '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import DeleteIcon from '@material-ui/icons/Delete'
import fbConfig from '../../../../../config/firebaseConfig'
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom'
import Tooltip from '@material-ui/core/Tooltip';
import { connect } from 'react-redux'
import AccountCircle from '@material-ui/icons/AccountCircle'
import MessageIcon from '@material-ui/icons/Message'
import WriteMessage from '../../GlobalComponents/Notifications/WriteMessage'
import Modal from '@material-ui/core/Modal'
import LinearProgress from '@material-ui/core/LinearProgress'


const styles = {
    card: {
      maxWidth: 320,
    },
    media: {
      // ⚠️ object-fit is not supported by IE 11.
      objectFit: 'cover',
    },
    bigAvatar:{
      marginTop: '32px',
      width: 60,
      height: 60,
    },
    avatar: {
      marginTop: '32px',
      color: '#fff',
      width: 60,
      height: 60,
      background: '#f2f2f2'
    },
    name: {
      textAlign: 'center',
      marginTop: '12px',
    },
    buttonBg:{
      background:"#f2f2f2"
    },
    modal: {
      position: 'absolute',
      background: 'white',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    linearColorPrimary: {
      backgroundColor: 'red',
    },
    linearBarColorPrimary: {
      backgroundColor: 'white',
    },
  };

class TrainerCard extends Component {

    state = {
      name: '',
      open: false,
      loading: ''
    }
    handleOpen = () => {
      this.setState({ open: true });
    };
  
    handleClose = () => {
      this.setState({ open: false });
    };

   deleteTrainer = (deleteTrainer) => {
    let newTrainer = this.state
    this.setState({
      ...this.state,
      loading: true
    })
    console.log(newTrainer)
    const functions = fbConfig.functions();
    const deleteUser= functions.httpsCallable('deleteUser');
      deleteUser({id: this.state.id, email: deleteTrainer.email,  companyId: this.state.companyId, name: this.state.name, role: this.state.role })
      .then(result => {
        this.setState({
          ...this.state,
          message: result.data.message,
          loading: false
        })
      })
       .catch(err => {
          this.setState({
            ...this.state,
            message: err.message,
            loading: false
          })
      });
   } 
  componentDidMount = () =>{
    if(this.props.trainer.id === this.props.profile.id){
      this.setState({
        name: 'You',
        id: this.props.trainer.id,
        role: this.props.trainer.role,
        companyId: this.props.trainer.companyId,
        button: 'disabled'
      })
    } else {
       this.setState({
        name: this.props.trainer.name,
        id: this.props.trainer.id,
        role: this.props.trainer.role,
        companyId: this.props.trainer.companyId,
        button: ''
     })
    }
   
   
  }
  render() {
    
    const { classes, trainer } = this.props;
    let imgUser = trainer.img
    const delButton = (
      this.state.button !== 'disabled' ? ' ': 'hidden'
    )
    return (
      <Fragment>
      <Card className={classes.card}>
      <CardActionArea className={classes.buttonBg}>
        <CardMedia
          image="https://dummyimage.com/600x400/f2f2f2/f2f2f2.png"
          title={this.state.name}
        >
        <Grid container justify="center" alignItems="center">
          { imgUser === '' ? 
            <Avatar alt={trainer.name} src={imgUser} className={classes.bigAvatar} />
          :
            <Avatar style={{background: this.props.color}} className={classes.avatar}>{((this.state.name || "").charAt(0) || "").toUpperCase()} </Avatar>

          }
          
       </Grid>
       <Typography className={classes.name}variant="h5" component="h2">
            {this.state.name}
          </Typography>
        </CardMedia>
        <CardContent>
         
         
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Link  to={{ pathname:'/trainerprofile', userId: this.state.id}} >  
          <Tooltip title="Trainer profile">
            <IconButton >
                <AccountCircle  />
            </IconButton>
          </Tooltip>
        </Link>
        <IconButton onClick={this.handleOpen}   style={{ visibility: delButton}}>
          <Tooltip title="Send message">
              <MessageIcon  />
          </Tooltip>    
        </IconButton>
        <IconButton onClick={this.deleteTrainer}  style={{marginLeft: 'auto', visibility: delButton}}>
          <Tooltip title="Delete Trainer">
              <DeleteIcon  />
          </Tooltip>    
        </IconButton>
        
      </CardActions>
      { this.state.loading === true ? 
              <LinearProgress  
              classes={{
                  colorPrimary: classes.linearColorPrimary,
                  barColorPrimary: classes.linearBarColorPrimary,
                }}
              
              style={{width: '100%'}}/>
              : "" 
              }
    </Card>
    <Modal  
      open={this.state.open}
      onClose={this.handleClose}>
      <div className={classes.modal}>
          <WriteMessage  sendMessageTo={this.state.id} name={this.state.name} role={this.state.role} />
      </div>
      
    </Modal>
    </Fragment>
    )
  }
}
TrainerCard.propTypes = {
    classes: PropTypes.object.isRequired,
  };
 const mapStateToProps= (state) => {
    return {
     profile: state.firebase.profile,
    }
  }
  export default withStyles(styles)(connect(mapStateToProps,null)(TrainerCard))